/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Checkbox, Form, Grid, Dropdown } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import './ModalEmail.css';

class ModalCoopSubmission extends Component {
  state = {
    templates: [
      { key: 0, value: 'ShareLinkTemplate', text: 'Monthly Social Creative' },
      { key: 1, value: 'LeaseSpecialsTemplate2', text: 'Lease Specials' },
      { key: 2, value: 'SingleAdTemplate', text: 'Single Ad' },
      { key: 3, value: 'CampaignTemplate', text: 'Campaign' }
    ],
    selectedTemplate: 'ShareLinkTemplate',
    message: '',
    successMessage: '',
    showPreview: false,
    emailSent: false,
    sendingEmail: false,
    users: [],
    selectedUsers: [],
    ccUser: false,
    ccCoop: false,
    notes: ''
  };

  componentDidMount() {
    this.setEmailTemplate();
    this.setUserOptions();
  }

  setUserOptions() {
    const { users } = this.props;
    this.setState({ users });
  }

  handleUserSelectChange = (event, data) => {
    const chosenOption = data;
    this.setState({ selectedUsers: chosenOption.value });
  };

  handleNotesChange = ({ target: { value } }) => {
    this.setState({
      notes: value
    });
  };

  handleCCUsersChange = () => {
    const { ccUser } = this.state;
    this.setState({
      ccUser: !ccUser
    });
  };

  handleCCCoopChange = () => {
    const { ccCoop } = this.state;
    this.setState({
      ccCoop: !ccCoop
    });
  };

  sendToUsers = () => {
    const { sendPDF, user } = this.props;
    const { selectedUsers, notes, ccUser } = this.state;
    for (let i = 0; i < selectedUsers.length; i += 1) {
      if (selectedUsers[i] !== null) {
        sendPDF(selectedUsers[i], notes);
      }
    }
    if (ccUser) {
      sendPDF(user.email, notes);
    }
  };

  sendPDF = () => {
    const { sendPDF } = this.props;
    const { selectedUsers, ccCoop, notes } = this.state;
    if (selectedUsers.length === 0 && !ccCoop) {
      toast('Please Choose A User Before Submitting', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true
      });
    } else {
      if (ccCoop) {
        sendPDF('Coop@constellationagency.com', notes);
      }
      this.sendToUsers();
      toast('The PDF will be sent to the selected users.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: true
      });
    }
  };

  setEmailTemplate = () => {
    const currentTemplateSelection = this.props.coopTypeSelection;
    const foundTemplate = this.state.templates.find((template) => {
      return template.text === currentTemplateSelection;
    });
    if (foundTemplate) {
      this.setState({ selectedTemplate: foundTemplate.value });
    }
  };

  render() {
    const { closeCoopModal } = this.props;
    const { users, notes, ccUser, ccCoop } = this.state;
    const { emailSent } = this.state.emailSent;

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <h4 className="preview-title">Send PDF To Other Alexia Users</h4>
              <h5>Please fill out the information below</h5>
              <hr />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>User List</h5>
              <Dropdown
                placeholder="User Emails"
                selection
                search
                multiple
                options={users}
                onChange={this.handleUserSelectChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>Notes (Optional)</h5>
              <div className="ui focus input">
                <input
                  type="text"
                  value={notes}
                  placeholder="Optional"
                  onChange={this.handleNotesChange}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Checkbox
                toggle
                checked={ccUser}
                onChange={this.handleCCUsersChange}
                label="CC Yourself"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Checkbox
                toggle
                checked={ccCoop}
                onChange={this.handleCCCoopChange}
                label="CC Co-Op"
              />
            </Grid.Column>
          </Grid.Row>

          <br />

          <Grid.Row>
            <Grid.Column>
              <hr />
              <div className="model-buttons-container">
                <Form.Button
                  size="small"
                  floated="left"
                  color="grey"
                  onClick={closeCoopModal}
                >
                  Close
                </Form.Button>
                {!emailSent ? (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="blue"
                    onClick={this.sendPDF}
                  >
                    Send
                  </Form.Button>
                ) : (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="grey"
                    onClick={closeCoopModal}
                  >
                    Close
                  </Form.Button>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default ModalCoopSubmission;



// WEBPACK FOOTER //
// ./src/screens/Presentation/ModalEmailDiffUsers.js